import React, { Component } from 'react'
import FbWrapper from '../../lib/FirebaseWrapper'

import './NavigatorLoginButton.css';

export default class NavigatorLoginButton extends Component {
  render () {
    let logoutButton = () => <span className='header-login-btn' onClick={() => FbWrapper.handleSignOut()}>Logout</span>
    let loginButton = () => <span className='header-login-btn' onClick={() => this.props.history.push('/login')}>Login</span>

    return (
      <div style={{paddingLeft: 8}}>
        {this.props.authUser ? logoutButton() : loginButton()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationBar/NavigatorLoginButton.js